import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
	Box,
	CssBaseline,
	Divider,
	IconButton,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Tooltip,
	Collapse,
	Avatar,
} from '@mui/material';
import {
	Dashboard as DashboardIcon,
	Category as CategoryIcon,
	ShoppingCart as OrderIcon,
	Store as ProductIcon,
	LocalShipping as WholesaleIcon,
	Call as CallIcon,
	QuestionAnswer as EnquiriesIcon,
	Group as GroupIcon,
	Logout as LogoutIcon,
	CurrencyRupee as CurrencyRupeeIcon,
	LocalOffer as LocalOfferIcon,
	ChevronLeft as ChevronLeftIcon,
	ChevronRight as ChevronRightIcon,
	ExpandLess,
	ExpandMore,
	BusinessCenter as BusinessCenterIcon,
	PersonAdd as PersonAddIcon,
	HourglassTop as HourglassTopIcon,
	VerifiedUser as VerifiedUserIcon,
	Inventory2 as InventoryIcon,
} from '@mui/icons-material';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Drawer, DrawerHeader } from '../../components/component/ThemeComponent';
import MyHeadings from '../../components/page/Vendor/Vendor-ui/Headings';
import { MeGet } from '../../services/api/Vendorpage/me';
import userContext from '../../configs/context/context';
import { REACT_APP_API_IMG } from '../../utlis';

export default function SideBar() {
	const theme = useTheme();
	const [open, setOpen] = React.useState(
		typeof window !== 'undefined' ? window.innerWidth >= 768 : false
	);
	const { setVendorme, Vendorme } = React.useContext<any>(userContext);
	const [vendorOpen, setVendorOpen] = React.useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const [permissions, setPermissions] = React.useState<any>(null);
	const domain = localStorage.getItem('slug');
	const slugChecker = location.pathname.split('/');
	const heading = slugChecker[2];
	const isXS = useMediaQuery(theme.breakpoints.only('xs'));
	const isSM = useMediaQuery(theme.breakpoints.only('sm'));
	const isMD = useMediaQuery(theme.breakpoints.only('md'));
	const isLG = useMediaQuery(theme.breakpoints.only('lg'));
	const isXL = useMediaQuery(theme.breakpoints.only('xl'));

	const handleDrawerOpen = () => setOpen(true);
	const handleDrawerClose = () => setOpen(false);
	const toggleVendorMenu = () => setVendorOpen(!vendorOpen);

	const handleLogout = () => {
		if (slugChecker.includes(domain as string)) {
			localStorage.removeItem('selli-vendor-accessToken');
			localStorage.removeItem('selli-vendor-refreshToken');
			navigate(`/${domain}/login`);
		} else {
			localStorage.removeItem('refresh');
			localStorage.removeItem('token');
			navigate('/login');
		}
	};

	React.useEffect(() => {
		if (location.pathname.startsWith('/vendor')) {
			setVendorOpen(true);
		}
	}, [location.pathname]);

	const menuItems = [
		{
			text: 'Dashboard',
			icon: <DashboardIcon />,
			path: slugChecker.includes(domain as string) ? `/${domain}/dashboard` : '/',
			permissionKey: 'dashboard',
		},
		{
			text: 'Categories',
			icon: <CategoryIcon />,
			path: slugChecker.includes(domain as string) ? `/${domain}/category` : '/category',
			permissionKey: 'category',
		},
		{
			text: 'Products',
			icon: <ProductIcon />,
			path: slugChecker.includes(domain as string) ? `/${domain}/product` : '/product',
			permissionKey: 'products',
		},
		{
			text: 'Order',
			icon: <OrderIcon />,
			path: slugChecker.includes(domain as string) ? `/${domain}/order` : '/order',

			permissionKey: 'order',
		},
		{
			text: 'Wholesale',
			icon: <WholesaleIcon />,
			path: slugChecker.includes(domain as string) ? `/${domain}/wholesale` : '/wholesale',
			permissionKey: 'wholesale',
		},
		{
			text: 'Product Enquiries',
			icon: <EnquiriesIcon />,
			path: slugChecker.includes(domain as string)
				? `/${domain}/product-enquiry`
				: '/product-enquiry',
			permissionKey: 'productEnquiry',
		},
		{
			text: 'Contact',
			icon: <CallIcon />,
			path: slugChecker.includes(domain as string) ? `/${domain}/enquiries` : '/enquiries',
			permissionKey: 'enquiries',
		},
		{ text: 'Users', icon: <GroupIcon />, path: '/users', permissionKey: 'users' },
		{
			text: 'CurrencyConvert',
			icon: <CurrencyRupeeIcon />,
			path: slugChecker.includes(domain as string)
				? `/${domain}/currency-converstion`
				: '/currency-converstion',
			permissionKey: 'currency-converstion',
		},
		{
			text: 'Coupon',
			icon: <LocalOfferIcon />,
			path: slugChecker.includes(domain as string) ? `/${domain}/coupon` : '/coupon',
			permissionKey: 'coupon',
		},
	];

	const vendorSubItems = [
		{ text: 'Create Vendor', path: '/vendor/create', icon: <PersonAddIcon /> },
		{ text: 'Request Vendor', path: '/vendor/request', icon: <HourglassTopIcon /> },
		{ text: 'Approved Vendors', path: '/vendor/approved', icon: <VerifiedUserIcon /> },
		{ text: 'Vendor Products', path: '/vendor/products', icon: <InventoryIcon /> },
	];

	const FetchData = async () => {
		if (slugChecker.includes(domain as string)) {
			const response = await MeGet(`vendors/${domain}/me`);
			if (response.success) {
				setVendorme(response.data);
				setPermissions(response.data.permissions);
			}
		}
	};
	React.useEffect(() => {
		FetchData();
	}, []);
	return (
		<Box sx={{ display: 'flex' }}>
			<CssBaseline />
			<Drawer variant="permanent" open={open}>
				<DrawerHeader
					sx={{
						justifyContent: 'space-between',
						alignItems: 'center',
						display: 'flex',
						flexDirection: 'row',
					}}
				>
					<Box
						sx={{
							display: open ? 'flex' : 'none',
							justifyContent: 'center',
							width: '100%',
						}}
					>
						<img
							src="/assets/selli-logo.png"
							width={100}
							loading="lazy"
							alt="Selli Logo"
						/>
					</Box>
					<IconButton
						onClick={open ? handleDrawerClose : handleDrawerOpen}
						sx={{
							'&:hover': {
								backgroundColor: 'rgba(0, 0, 0, 0.1)',
								color: 'inherit',
							},
						}}
					>
						{open ? (
							theme.direction === 'rtl' ? (
								<ChevronRightIcon />
							) : (
								<ChevronLeftIcon />
							)
						) : theme.direction === 'rtl' ? (
							<ChevronLeftIcon />
						) : (
							<ChevronRightIcon />
						)}
					</IconButton>
				</DrawerHeader>

				<Divider />

				<List>
					{menuItems
						.filter((item) =>
							slugChecker.includes(domain as string)
								? permissions?.[item.permissionKey]?.read
								: true
						)
						.map((item) => (
							<ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
								<ListItemButton
									sx={[
										{
											minHeight: 48,
											px: 2.5,
											backgroundColor:
												location.pathname === item.path
													? '#0C8040'
													: 'inherit',
											color:
												location.pathname === item.path
													? 'white'
													: 'inherit',
											'&:hover': {
												color: '#fff',
												backgroundColor: '#0C8040',
											},
										},
										open
											? { justifyContent: 'initial' }
											: { justifyContent: 'center' },
									]}
									onClick={() => {
										navigate(item.path);
									}}
								>
									<Tooltip title={item.text} placement="right" arrow>
										<ListItemIcon
											sx={[
												{
													minWidth: 0,
													justifyContent: 'center',
													color:
														location.pathname === item.path
															? 'white'
															: 'inherit',
												},
												open ? { mr: 3 } : { mr: 'auto' },
											]}
										>
											{item.icon}
										</ListItemIcon>
									</Tooltip>
									<ListItemText
										primary={item.text}
										sx={{ opacity: open ? 1 : 0 }}
									/>
								</ListItemButton>
							</ListItem>
						))}
				</List>

				{!slugChecker.includes(domain as string) && (
					<ListItem disablePadding sx={{ display: 'block' }}>
						<ListItemButton
							onClick={toggleVendorMenu}
							sx={[
								{
									minHeight: 48,
									px: 2.5,
									'&:hover': {
										color: '#fff',
										backgroundColor: '#0C8040',
									},
								},
								open ? { justifyContent: 'initial' } : { justifyContent: 'center' },
							]}
						>
							<Tooltip title="Vendors" placement="right" arrow>
								<ListItemIcon
									sx={[
										{ minWidth: 0, justifyContent: 'center', color: 'inherit' },
										open ? { mr: 3 } : { mr: 'auto' },
									]}
								>
									<BusinessCenterIcon />
								</ListItemIcon>
							</Tooltip>
							<ListItemText primary="Vendors" sx={{ opacity: open ? 1 : 0 }} />
							{open && (vendorOpen ? <ExpandLess /> : <ExpandMore />)}
						</ListItemButton>
						<Collapse in={vendorOpen} timeout="auto" unmountOnExit>
							<List component="div" disablePadding>
								{vendorSubItems.map((subItem) => (
									<ListItemButton
										key={subItem.text}
										sx={{
											pl: open ? 4 : 2,
											backgroundColor:
												location.pathname === subItem.path
													? '#0C8040'
													: 'inherit',
											color:
												location.pathname === subItem.path
													? 'white'
													: 'inherit',
											'&:hover': {
												backgroundColor: '#0C8040',
												color: 'white',
											},
										}}
										onClick={() => {
											navigate(subItem.path);
										}}
									>
										<ListItemIcon
											sx={{
												minWidth: 0,
												mr: open ? 2 : 'auto',
												justifyContent: 'center',
												color:
													location.pathname === subItem.path
														? 'white'
														: 'inherit',
											}}
										>
											{subItem.icon}
										</ListItemIcon>
										<ListItemText
											primary={subItem.text}
											sx={{ opacity: open ? 1 : 0 }}
										/>
									</ListItemButton>
								))}
							</List>
						</Collapse>
					</ListItem>
				)}

				<Divider />

				<List sx={{ marginTop: 'auto' }}>
					<ListItem disablePadding sx={{ display: 'block' }}>
						<ListItemButton
							onClick={handleLogout}
							sx={[
								{
									minHeight: 48,
									px: 2.5,
									color: '#000',
									'&:hover': {
										color: '#fff',
										backgroundColor: '#0C8040',
										fill: '#fff',
									},
								},
								open ? { justifyContent: 'initial' } : { justifyContent: 'center' },
							]}
						>
							<ListItemIcon
								sx={[
									{ minWidth: 0, justifyContent: 'center', color: 'inherit' },
									open ? { mr: 3 } : { mr: 'auto' },
								]}
							>
								<Tooltip title="Logout" placement="right">
									<LogoutIcon />
								</Tooltip>
							</ListItemIcon>
							<ListItemText primary="Logout" sx={{ opacity: open ? 1 : 0 }} />
						</ListItemButton>
					</ListItem>
				</List>
			</Drawer>

			<Box
				component="main"
				sx={{
					flexGrow: 1,
					p: isXS ? 1 : isSM ? 2 : isMD ? 3 : isLG ? 4 : 5,
					width: isXS || isSM || isMD || isLG || isXL ? 'calc(100% - 65px)' : 'auto',
				}}
			>
				<ToastContainer position="top-right" autoClose={3000} />
				{slugChecker.includes(domain as string) && (
					<>
						<Box
							sx={{
								position: 'fixed', // fix at viewport bottom
								top: 0,
								left: open ? 240 : { xs: '57px', md: 67 },
								right: 0,
								bgcolor: 'background.paper', // ensure background covers content underneath
								boxShadow: '0 -2px 8px rgba(0,0,0,0.1)', // subtle shadow on top
								p: 1,
								zIndex: 1300, // above most content (MUI modal default zIndex is 1300)
							}}
						>
							<Box
								sx={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
								}}
							>
								<MyHeadings
									Title={heading}
									style={{ textTransform: 'capitalize', fontSize: '2rem' }}
								/>
								<Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
									<Box onClick={() => navigate(`/${domain}/me`)}>
										<Avatar
											alt={Vendorme?.companyName}
											src={`${REACT_APP_API_IMG}${Vendorme?.logo}`}
										/>
									</Box>
								</Box>
							</Box>
						</Box>
					</>
				)}
				<Box sx={{ pt: slugChecker.includes(domain as string) ? { xs: 8, md: 6 } : 0 }}>
					<Outlet />
				</Box>
			</Box>
		</Box>
	);
}
